<template>
    <toolbar-option type="stacked">
        <template slot="secondary">
            <button type="button" @click="onReset">
                <font-awesome-icon :icon="['fas', 'undo']" />
            </button>
        </template>

        <template slot="primary">
            <directional-pad press-enabled @input="onInput" />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';
import DirectionalPad from '@/components/utilities/directional-pad';

const CUSTOM_ATTR_NAME = 'offset';

export default {
    name: 'control-offset',
    components: { DirectionalPad },
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Move Element',
            x: 0,
            y: 0,
            positionChecked: false,
        };
    },

    watch: {
        changedOption({ option }) {
            if (option === 'placement') this.onConflict();
        },
    },

    methods: {
        onInput(direction) {
            switch (direction) {
                case 'topLeft':
                    this.y--;
                    this.x--;
                    break;

                case 'top':
                    this.y--;
                    break;

                case 'topRight':
                    this.y--;
                    this.x++;
                    break;

                case 'left':
                    this.x--;
                    break;

                case 'right':
                    this.x++;
                    break;

                case 'bottomLeft':
                    this.y++;
                    this.x--;
                    break;

                case 'bottom':
                    this.y++;
                    break;

                case 'bottomRight':
                    this.y++;
                    this.x++;
                    break;

                default:
                    // do nothing
            }

            const offsetCoords = {
                x: this.x,
                y: this.y,
            };

            this.selectedElements.forEach((elem, index) => {
                if (!this.positionChecked) {
                    const computedPosition = window.getComputedStyle(elem.$el).getPropertyValue('position');

                    if (computedPosition === 'static') {
                        this.addFlexClass({
                            value: 'relative',
                            tailwindDefinitionProp: 'position',
                        }, index);
                    }

                    this.positionChecked = true;
                }

                elem.setElementData(CUSTOM_ATTR_NAME, offsetCoords);
            });

            this.onOptionChange(offsetCoords);
        },

        onReset() {
            this.onConflict();
            this.onOptionChange({ x: 0, y: 0 });
        },

        onSelectedElement() {
            const offset = this.selectedElements[0].getElementData(CUSTOM_ATTR_NAME);

            if (offset) {
                this.x = offset.x;
                this.y = offset.y;
            }
        },

        onConflict() {
            this.x = 0;
            this.y = 0;

            this.selectedElements.forEach((elem) => {
                elem.removeElementData(CUSTOM_ATTR_NAME);
            });
        },
    },
};
</script>
